import React from "react";

const ShoppingCart = () => {
	return <div>Hello Shopping Cart</div>;
};

export default ShoppingCart;
